import { fromJS } from 'immutable'

import * as actionTypes from './actionTypes'


const defaultState = fromJS({
    image_data: [
        // {
        //     "lc": 1,
        //     "type": "constructor",
        //     "id": [
        //       "langchain",
        //       "schema",
        //       "image",
        //       "Image"
        //     ],
        //     "kwargs": {
        //         "content": "https://ja-material-formal.oss-cn-shenzhen.aliyuncs.com/Material/2022-03-18/150defc08ab64d43a016b4777d19dd20.jpg",
        //         "metadata": {
        //             "updated_at": "2025-01-07 17:37:20",
        //             "name": "LE1303",
        //             "id": 717,
        //             "url": "https://ja-material-formal.oss-cn-shenzhen.aliyuncs.com/Material/2022-03-18/150defc08ab64d43a016b4777d19dd20.jpg",
        //             "description": null,
        //             "created_at": "2025-01-07 17:37:20",
        //             "image_id": "0c57e4ba00f7ba9a9c3b3faa2b5db736_LE1303",
        //             "score": 1,
        //             "meta_data": {
        //                 "primary": "石材",
        //                 "secondary": "人造石"
        //             }
        //         }
        //     }
        // },
    ],
    search_time: 0,
})

const reducer = (state=defaultState, action) => {
    switch(action.type) {
        case actionTypes.SET_IMAGE_DATA:
            return state.merge({
                'image_data': fromJS(action.data),
            })
        case actionTypes.SET_SEARCH_TIME:
            return state.set('search_time', action.value)
        default:
            return state
    }
}

export default reducer
